import axios from 'axios';
import { URL_CORE_PRICING_MARKET_LIST_FILE_UPLOAD } from '../../../end-points';
import { toastWarn } from '../../../utils/toasts';

export async function uploadFile(file, type, dgNumber) {
   try {
      const payload = {
         file,
         type,
         ...(!!dgNumber && { dgNumber: parseInt(dgNumber) }),
      };

      const uploadApiResponse = await axios.post(
         URL_CORE_PRICING_MARKET_LIST_FILE_UPLOAD,
         payload,
         {
            headers: {
               'Content-Type': 'multipart/form-data',
            },
         }
      );

      if (uploadApiResponse?.status !== 200) {
         toastWarn(uploadApiResponse?.data?.message);
      }

      return uploadApiResponse;
   } catch (error) {
      toastWarn(error.message);
      console.warn('error in uploading file', error);
   }
}
